import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ConsoleErrorService } from './console-error.service';

/**
 * HTTP Interceptor zum Erfassen von Netzwerkfehlern.
 * Leitet HTTP-Fehler an den ConsoleErrorService weiter.
 */
export const errorCaptureInterceptor: HttpInterceptorFn = (req, next) => {
	const ces = inject(ConsoleErrorService);

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			// WMS GetCapabilities-Fehler nicht erfassen — diese werden erwartet
			// (Server nicht erreichbar, CORS, etc.) und separat behandelt
			const isWmsCapabilities = req.params.get('REQUEST') === 'GetCapabilities';

			// Nur echte Fehler erfassen, nicht 4xx Client-Fehler die erwartet sein können
			if ((error.status === 0 || error.status >= 500) && !isWmsCapabilities) {
				const errorDetail = error.message || error.statusText || 'Netzwerkfehler';
				const message = `HTTP ${error.status}: ${errorDetail} - ${req.url}`;
				ces.captureHttpError(message);
			}
			return throwError(() => error);
		})
	);
};
